'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _Grade = require('./Grade.css');

var _Grade2 = _interopRequireDefault(_Grade);

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import ReactTooltip from 'react-tooltip'

var Grade = (_dec = (0, _reactCssModules2.default)(_Grade2.default, { allowMultiple: false }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Grade, _Component);

  function Grade(props) {
    (0, _classCallCheck3.default)(this, Grade);
    return (0, _possibleConstructorReturn3.default)(this, (Grade.__proto__ || (0, _getPrototypeOf2.default)(Grade)).call(this, props));
  }

  (0, _createClass3.default)(Grade, [{
    key: 'render',
    value: function render() {
      var grade = this.props.grade;

      var charGrade = _format2.default.score(grade);
      var safeGrade = charGrade === 'N/A' ? 'NA' : charGrade;

      var addSuffix = function addSuffix(s) {
        return s ? 'grade-' + safeGrade + '-' + s : 'grade-' + safeGrade;
      };
      var style = addSuffix(null);
      if (this.props.large) {
        style = addSuffix('large');
      } else if (this.props.block) {
        style = addSuffix('block');
      } else if (this.props.blocksmall) {
        style = addSuffix('block-small');
      } else if (this.props.square) {
        style = addSuffix('square');
      }

      var wrapStyle = 'grade-wrap';
      if (this.props.large || this.props.block) {
        wrapStyle = 'grade-wrap-large';
      } else if (this.props.square) {
        wrapStyle = 'grade-wrap-square';
      }

      var shield = require('../../../static/images/icn-engagement-shield.svg');
      //
      return _react2.default.createElement(
        'div',
        { styleName: wrapStyle },
        _react2.default.createElement(
          'div',
          { styleName: style },
          charGrade === 'E' ? _react2.default.createElement('img', {
            src: shield,
            alt: 'Known Sustainability Engager',
            styleName: 'grade-engagement-icon'
          }) : charGrade
        )
      );
    }
  }]);
  return Grade;
}(_react.Component), _class2.propTypes = {
  grade: _react.PropTypes.number.isRequired,
  large: _react.PropTypes.bool,
  block: _react.PropTypes.bool,
  blocksmall: _react.PropTypes.bool,
  square: _react.PropTypes.bool
}, _temp)) || _class);
exports.default = Grade;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/core/Grade/Grade.js
// module id = 1438
// module chunks = 0